import type { TableSettingsDialogProps } from "./types-table-settings-dialog";
import { useTableSettingsDialog } from "./use-table-settings-dialog";
import { TableSettingsDialogView } from "./view-table-settings-dialog";

/**
 * "Configuração da Tabela" (Padrões Globais) sobre o `Dialog`: tamanho (Confortável/Compacto) e, com mais de
 * 6 colunas, "Mostrar e Ocultar Colunas". Só Aplicar efetiva o rascunho do `useTableSettings`; Cancelar descarta.
 */
export function TableSettingsDialog<C extends string>(props: TableSettingsDialogProps<C>) {
  const viewModel = useTableSettingsDialog(props);

  return <TableSettingsDialogView {...viewModel} />;
}
